<template>
  <aside>
    <div id="scoreWrap">
      <div id="scoreNum">{{score()}}</div>
      <div id="scoreLabel">{{$store.getters['getUIText']('score')}}</div>
    </div>
    <patient :patient="patient1" v-if="patient1" :selected="selectedSlot === 0"></patient>
    <patient :patient="patient2" v-if="patient2" :selected="selectedSlot === 1"></patient>
  </aside>
</template>

<script>
import Patient from "@/components/patient";
import GameManager from "@/assets/js/GameManager";

export default {
  name: "sidebar",
  components: {Patient},
  computed:{
    patient1(){
      return GameManager.patients[0];
    },
    patient2(){
      return GameManager.patients[1];
    },
    selectedSlot(){
      return GameManager.selectedSlot;
    }
  },
  methods: {
    score(){
      return GameManager.score;
    }
  }
}
</script>

<style scoped lang="less">
@import (reference) '../assets/less/colors';

aside{
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  width: 38vw;
  height: 100%;
  box-shadow: inset -100px 3vw 3vw -100px #000000,
  inset 100px 3vw 3vw -100px #000000;
  background: radial-gradient(circle at center -50%, transparent, transparent 75%, #520d0d 107%),
  radial-gradient(transparent, transparent 65%, #415b72),
  url("../assets/images/patient-tile-bg.png") round,
  radial-gradient(#7c9ac0, #7c9ac0 30%, #415b72);
}

#scoreWrap{
  position: absolute;
  color: @white;
  //font-weight: bold;
  font-family: monospace;
  text-align: right;
  top: 0.5rem;
  right: 1rem;
  text-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
}
#scoreNum{
  font-size: 2rem;
}
#scoreLabel{
  font-size: 1.25rem;
}

</style>
